export const TRAINING_SESSION_REMARKS_FIELD_NAME = "remarks";
export const TRAINING_SESSION_ACHIEVED_FIELD_NAME = "achieved";
